import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "item", "name"]

    connect() {
        console.log("Search controller connected")
    }

    filter() {
        const query = this.inputTarget.value.toLowerCase().trim()

        this.itemTargets.forEach(item => {
            // Find the name within the item. 
            // We assume there's a name target or we look for a specific selector.
            // Let's use nameTarget if possible, or fallback to text content if simple.

            const nameElement = item.querySelector('[data-search-target="name"]')
            const name = nameElement ? nameElement.textContent.toLowerCase() : item.textContent.toLowerCase()

            if (name.includes(query)) {
                item.classList.remove("hidden")
            } else {
                item.classList.add("hidden")
            }
        })
    }
}
